import { MomentInput, utc } from 'moment';

export const formatDate = (date: MomentInput, format: string = 'YYYY-MM-DD[T]HH:mm'): string => {
  if (!date || !utc(date).isValid()) return '';
  return utc(date).format(format).replace('Z', '');
};